import { FormGroup, FormControl } from '@angular/forms';
import { BaseComponent } from './base.component';

export class ControlBase extends BaseComponent {

    constructor() {
        super();
    }
}
